/**
 * Where the two catalog PDFs live.
 *
 * Served straight out of apps/web/public, so they are same-origin: no CORS, and the `download`
 * attribute works. Cloudflare Pages caps a single static asset at 25 MiB — if a catalog ever
 * outgrows that, move it to R2 and set its env var rather than changing any code.
 */
export const PRODUCTS_CATALOG_URL =
  import.meta.env.VITE_PRODUCTS_CATALOG_URL ?? '/catalog-produse.pdf'

export const SERVICES_CATALOG_URL =
  import.meta.env.VITE_SERVICES_CATALOG_URL ?? '/catalog-servicii.pdf'
